const wrapperCls = "_vcwd947ql";

export { wrapperCls };
import "./_video-component.style.linaria.module.css";
//# sourceMappingURL=_video-component.style.js.map
